import { IEnvironment } from '@env/environment.interface';
import packageJson from '../../package.json';

export const environment: IEnvironment = {
  name: 'release',
  production: true,
  API_URL: 'https://api-release.talent.silae.fr',
  MY_SILAE_LABEL: 'mySilae (release)',
  MY_SILAE_URL: '',
  POST_HOG_ENABLED: false,
  POST_HOG_API_KEY: '',
  POST_HOG_HOST: '',
  VERSION: packageJson.version,
  WHITELISTED_DOMAIN: 'api-release.talent.silae.fr',
  VUE: 'https://release.t.my.silae.fr',
};
